import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import CookieDisclaimer from '../../components/CookieDisclaimer';
import SEO from '../../components/SEO';
import { apiGet } from '../../api/client';
import { ToolSectionRenderer } from './ToolPageSections';
import '../../styles.css';

export default function ToolPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    apiGet(`/tool-pages/${slug}`)
      .then(setPage)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <>
        <Navbar />
        <main className="container" style={{ padding: '6rem 0' }}>
          <div className="video-loading"><div className="spinner"></div></div>
        </main>
        <Footer />
      </>
    );
  }

  if (error || !page) {
    return (
      <>
        <Navbar />
        <main className="container" style={{ padding: '6rem 0' }}>
          <h1>Tool not found</h1>
          <p>{error || 'This tool page does not exist.'}</p>
          <Link to="/tools" className="btn btn-primary">Browse Tools</Link>
        </main>
        <Footer />
      </>
    );
  }

  const seo = page.seo || {};
  const hero = page.hero || {};
  const sections = page.content?.sections || [];

  return (
    <>
      <SEO
        title={page.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url || `https://zemaxi.com/tools/${slug}`}
        image={hero.image ? new URL(hero.image, "https://zemaxi.com").href : undefined}
      />
      <Navbar />
      <CookieDisclaimer />
      <main>
        <section className="trophy-tracker-hero">
          <div className="container">
            <h1>
              {hero.title}
              {hero.highlight && <span className="highlight"> {hero.highlight}</span>}
            </h1>
            {hero.subtitle && <p>{hero.subtitle}</p>}
          </div>
        </section>

        <section className="trophy-tracker-content">
          <div className="container">
            {hero.image && (
              <div className="trophy-tracker-image">
                <img src={hero.image} alt={page.title} />
              </div>
            )}
            {sections.filter((section) => !section.hidden).map((section, i) => (
              <ToolSectionRenderer section={section} key={`${section.type}-${i}`} />
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
